import React from "react";
import "./style.css";

export const Desktop = () => {
  return (
    <div className="desktop">
      <div className="scroll-button">
        <div className="overlap-group">
          <img className="vector" alt="Vector" src="/img/vector.svg" />
          <div className="bg" />
        </div>
      </div>
      <div className="max">
        <header className="header">
          <div className="frame">
            <div className="text-wrapper">X.Name</div>
            <div className="nav-elements">
              <div className="div">主页</div>
              <div className="text-wrapper-2">加入测评</div>
              <div className="div">微信公众号</div>
              <div className="div">登陆</div>
              <button className="button">
                <div className="div-wrapper">
                  <div className="text-wrapper-3">注册</div>
                </div>
              </button>
            </div>
          </div>
          <div className="frame-2">
            <div className="image">
              <img className="img" alt="Image" src="/img/image-2-28.png" />
            </div>
            <div className="frame-3">
              <div className="images">
                <img className="image-2" alt="Image" src="/img/image-1.png" />
              </div>
              <div className="text-button">
                <div className="frame-4">
                  <div className="ultimate">
                    <div className="text-wrapper-4">大众</div>
                  </div>
                  <div className="text-wrapper-5">测试</div>
                  <div className="text-wrapper-6">不求最专业，只求最有用</div>
                  <button className="overlap-group-wrapper">
                    <div className="overlap-group-2">
                      <div className="text-wrapper-7">参与测试</div>
                    </div>
                  </button>
                </div>
              </div>
              <div className="images-2" />
            </div>
            <div className="image-wrapper">
              <img className="image-3" alt="Image" src="/img/image-227.png" />
            </div>
          </div>
        </header>
      </div>
      <div className="logos">
        <div className="bg-2" />
        <div className="logos-2">
          <img className="logo" alt="Logo" src="/img/logo-4.png" />
          <img className="logo-2" alt="Logo" src="/img/logo-3.png" />
          <img className="logo-3" alt="Logo" src="/img/logo-2.png" />
          <img className="logo-4" alt="Logo" src="/img/logo-1.png" />
          <img className="logo-5" alt="Logo" src="/img/logo.png" />
        </div>
      </div>
      <div className="max">
        <div className="new-arrivals">
          <div className="categories">
            <div className="category">
              <div className="overlap-group-3">
                <div className="text-wrapper-8">纸品</div>
              </div>
            </div>
            <div className="category">
              <div className="overlap">
                <div className="text-wrapper-9">日用品</div>
              </div>
            </div>
            <div className="category">
              <div className="overlap-group-3">
                <div className="text-wrapper-8">数码</div>
              </div>
            </div>
            <div className="category">
              <div className="overlap-group-3">
                <div className="text-wrapper-8">家电</div>
              </div>
            </div>
            <div className="category">
              <div className="overlap-group-3">
                <div className="text-wrapper-8">活动</div>
              </div>
            </div>
          </div>
          <div className="products">
            <div className="product">
              <div className="texts">
                <div className="text-wrapper-10">我要评论</div>
                <div className="text-wrapper-11">Almost Sold Out</div>
                <p className="element">
                  <span className="span">(4.1k) </span>
                  <span className="text-wrapper-12">热评</span>
                </p>
                <img className="stars" alt="Stars" src="/img/stars.png" />
                <div className="name-brand">
                  <div className="text-wrapper-13">用户名1</div>
                  <div className="text-wrapper-14">物品1</div>
                </div>
              </div>
              <img className="images-3" alt="Images" src="/img/images-5.png" />
            </div>
            <div className="product">
              <div className="texts">
                <div className="text-wrapper-10">我要评论</div>
                <div className="text-wrapper-11">Almost Sold Out</div>
                <p className="element">
                  <span className="span">(4.1k) </span>
                  <span className="text-wrapper-15">热评</span>
                </p>
                <img className="stars" alt="Stars" src="/img/stars.png" />
                <div className="name-brand-2">
                  <div className="text-wrapper-13">Al Karam</div>
                  <div className="text-wrapper-14">纸巾</div>
                </div>
              </div>
              <img className="images-4" alt="Images" src="/img/images-4.png" />
            </div>
            <div className="product">
              <div className="texts">
                <div className="text-wrapper-10">我要评论</div>
                <div className="text-wrapper-11">Almost Sold Out</div>
                <p className="element">
                  <span className="span">(4.1k) </span>
                  <span className="text-wrapper-15">热评</span>
                </p>
                <img className="stars" alt="Stars" src="/img/stars.png" />
                <div className="name-brand-3">
                  <div className="text-wrapper-13">Al Karam</div>
                  <div className="text-wrapper-14">精酿啤酒</div>
                </div>
              </div>
              <img className="images-4" alt="Images" src="/img/images-3.png" />
            </div>
            <div className="product">
              <div className="texts">
                <div className="text-wrapper-10">我要评论</div>
                <div className="text-wrapper-11">Almost Sold Out</div>
                <p className="element">
                  <span className="span">(4.1k) </span>
                  <span className="text-wrapper-15">热评</span>
                </p>
                <img className="stars" alt="Stars" src="/img/stars.png" />
                <div className="name-brand-2">
                  <div className="text-wrapper-13">Al Karam</div>
                  <div className="text-wrapper-14">玩具</div>
                </div>
              </div>
              <img className="images-4" alt="Images" src="/img/images-2.png" />
            </div>
            <div className="product">
              <div className="texts">
                <div className="text-wrapper-10">我要评论</div>
                <div className="text-wrapper-11">Almost Sold Out</div>
                <p className="element">
                  <span className="span">(4.1k) </span>
                  <span className="text-wrapper-15">热评</span>
                </p>
                <img className="stars" alt="Stars" src="/img/stars.png" />
                <div className="name-brand-4">
                  <div className="text-wrapper-13">Al Karam</div>
                  <div className="text-wrapper-14">筋膜仪</div>
                </div>
              </div>
              <img className="images-4" alt="Images" src="/img/images-1.png" />
            </div>
            <div className="product">
              <div className="texts">
                <div className="text-wrapper-10">我要评论</div>
                <div className="text-wrapper-11">Almost Sold Out</div>
                <p className="element">
                  <span className="span">(4.1k) </span>
                  <span className="text-wrapper-15">热评</span>
                </p>
                <img className="stars" alt="Stars" src="/img/stars.png" />
                <div className="name-brand-5">
                  <div className="text-wrapper-13">Al Karam</div>
                  <div className="text-wrapper-14">White Shirt</div>
                </div>
              </div>
              <img className="images-3" alt="Images" src="/img/images.png" />
            </div>
          </div>
          <button className="overlap-group-wrapper">
            <div className="overlap-group-2">
              <div className="text-wrapper-16">更多</div>
            </div>
          </button>
        </div>
      </div>
      <div className="container-wrapper">
        <div className="container">
          <div className="col">
            <div className="section-text">
              <div className="top">
                <div className="secondary-headline">加入测试</div>
              </div>
            </div>
            <div className="list">
              <div className="list-item-with">
                <img
                  className="icon-jam-icons"
                  alt="Icon jam icons"
                  src="/img/icon-jam-icons-outline-logos-check.svg"
                />
                <p className="text">Est et in pharetra magna adipiscing ornare aliquam.</p>
              </div>
              <div className="list-item-with">
                <img
                  className="icon-jam-icons"
                  alt="Icon jam icons"
                  src="/img/icon-jam-icons-outline-logos-check.svg"
                />
                <p className="text">Tellus arcu sed consequat ac velit ut eu blandit.</p>
              </div>
              <div className="list-item-with">
                <img
                  className="icon-jam-icons"
                  alt="Icon jam icons"
                  src="/img/icon-jam-icons-outline-logos-check.svg"
                />
                <p className="text">Ullamcorper ornare in et egestas dolor orci.</p>
              </div>
            </div>
            <button className="text-container-wrapper">
              <div className="text-container">
                <div className="button-text">Sign up now</div>
              </div>
            </button>
          </div>
          <div className="deco-video">
            <div className="overlap-2">
              <div className="overlap-group-4">
                <div className="rectangle" />
                <div className="rectangle-2" />
                <div className="rectangle-3" />
                <div className="rectangle-4" />
              </div>
              <div className="rectangle-5" />
            </div>
          </div>
          <img className="screen-desktop" alt="Screen desktop" src="/img/screen-desktop.svg" />
          <div className="rectangle-6" />
        </div>
      </div>
      <div className="section-wrapper">
        <div className="section">
          <img className="vector-2" alt="Vector" src="/img/vector-13.svg" />
          <div className="row">
            <div className="top-wrapper">
              <div className="top">
                <div className="secondary-headline">编辑精选</div>
              </div>
            </div>
            <button className="button-2">
              <div className="text-container">
                <div className="button-text-2">More Articles</div>
              </div>
              <img
                className="icon-jam-icons"
                alt="Icon jam icons"
                src="/img/icon-jam-icons-outline-logos-arrow-right.svg"
              />
            </button>
          </div>
          <div className="row-2">
            <div className="content-box">
              <div className="picture" />
              <div className="content">
                <div className="title-category">
                  <div className="title-container">
                    <div className="title">Congue velit risus</div>
                  </div>
                </div>
                <p className="paragraph">Nunc gravida semper tellus neque scelerisque eget tincidunt in.</p>
              </div>
              <div className="buttons-group">
                <button className="button-2">
                  <div className="button-text-wrapper">
                    <div className="button-text-2">Read article</div>
                  </div>
                  <img
                    className="icon-jam-icons"
                    alt="Icon jam icons"
                    src="/img/icon-jam-icons-outline-logos-arrow-right.svg"
                  />
                </button>
              </div>
            </div>
            <div className="content-box">
              <div className="picture-2" />
              <div className="content">
                <div className="title-category">
                  <div className="title-container">
                    <div className="title">Ut mauris</div>
                  </div>
                </div>
                <p className="paragraph">Phasellus venenatis massa bibendum posuere dictum tristique.</p>
              </div>
              <div className="buttons-group">
                <button className="button-2">
                  <div className="button-text-wrapper">
                    <div className="button-text-2">Read article</div>
                  </div>
                  <img
                    className="icon-jam-icons"
                    alt="Icon jam icons"
                    src="/img/icon-jam-icons-outline-logos-arrow-right.svg"
                  />
                </button>
              </div>
            </div>
            <div className="content-box">
              <div className="picture-3" />
              <div className="content">
                <div className="title-category">
                  <div className="title-container">
                    <div className="title">Aliquam tortor nunc</div>
                  </div>
                </div>
                <p className="paragraph">Leo mollis fermentum praesent in condimentum id velit purus in.</p>
              </div>
              <div className="buttons-group">
                <button className="button-2">
                  <div className="button-text-wrapper">
                    <div className="button-text-2">Read article</div>
                  </div>
                  <img
                    className="icon-jam-icons"
                    alt="Icon jam icons"
                    src="/img/icon-jam-icons-outline-logos-arrow-right.svg"
                  />
                </button>
              </div>
            </div>
            <div className="content-box">
              <div className="picture-4" />
              <div className="content">
                <div className="title-category">
                  <div className="title-container">
                    <div className="title">Fusce non morbi</div>
                  </div>
                </div>
                <p className="paragraph">In sed bibendum metus pretium cursus tellus pharetra.</p>
              </div>
              <div className="buttons-group">
                <button className="button-2">
                  <div className="button-text-wrapper">
                    <div className="button-text-2">Read article</div>
                  </div>
                  <img
                    className="icon-jam-icons"
                    alt="Icon jam icons"
                    src="/img/icon-jam-icons-outline-logos-arrow-right.svg"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="footer">
        <img className="separator" alt="Separator" src="/img/separator.svg" />
        <div className="data">
          <div className="logo-itema">
            <div className="items">
              <div className="text-wrapper-17">主页</div>
              <div className="text-wrapper-18">加入测评</div>
              <div className="text-wrapper-17">微信公众号</div>
              <div className="text-wrapper-17">关于</div>
              <div className="text-wrapper-17">FAQ,s</div>
            </div>
            <div className="text-wrapper-19">X.Names</div>
          </div>
          <p className="copyright-text">Copyright © 2022 X.names . All Rights Reseved.</p>
        </div>
      </footer>
    </div>
  );
};
